import { Injectable } from '@angular/core';
import { LoginService } from './login.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '@service/notification.service';
import { Router } from '@angular/router';
import { ClientLoginQueryParams } from '@model/client-login-query-params';

@Injectable({
  providedIn: 'root',
})
export class DesktopClientService {
  externalDeviceInfo: any;

  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private loginService: LoginService
  ) {}

  setExtInfo(params) {
    this.externalDeviceInfo = params;
  }

  getExtInfo() {
    return this.externalDeviceInfo;
  }

  desktopClientCheckAccess(clientLoginQueryParams: ClientLoginQueryParams, accessToken: string, data): void {
    this.loginService.desktopClientCheckAccess(accessToken).subscribe(
      res => {
        this.setExtInfo(null);
        const route =
          clientLoginQueryParams.serviceRedirectUrl +
          '#access_token=' +
          data.access_token +
          '&expires_at=' +
          data.expire_time +
          '&token_type=bearer&email=' +
          data.client_id +
          '&refresh_token=' +
          data.refresh_token_info.refresh_token +
          '&refresh_token_expires=' +
          data.refresh_token_info.expire_time;
        window.location.href = route;
        window.location.href = '/home';
      },
      error => {
        this.notificationService.showError(this.translateService.instant(error.error.message));
        setTimeout(() => {
          window.location.href = '/home';
        }, 3000);
      }
    );
  }
}
